<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="90%">
    <template v-slot:title>Pricing Logs</template>
    <v-data-table :items="value" :headers="headers">
      <template v-slot:item.date="{ item }">{{
        item.date | formatDate
      }}</template>
    </v-data-table>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog.vue";
export default {
  name: "pricing-log-dialog",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      headers: [
        {
          text: "Date",
          value: "date",
          name: "date",
        },
        {
          text: "Time",
          value: "time",
          name: "time",
        },
        {
          text: "User",
          value: "username",
          name: "usrname",
        },
        {
          text: "Item Cost",
          value: "itemBuy",
          name: "itemBuy",
        },
        {
          text: "Item Sell",
          value: "itemSell",
          name: "itemSell",
        },
        {
          text: "Adult Cost",
          value: "adultBuy",
          name: "adultBuy",
        },
        {
          text: "Adult Sell",
          value: "adultSell",
          name: "adultSell",
        },
        {
          text: "Child Cost",
          value: "childBuy",
          name: "childBuy",
        },
        {
          text: "Child Sell",
          value: "childSell",
          name: "childSell",
        },
        {
          text: "Infant Cost",
          value: "infantBuy",
          name: "infantBuy",
        },
        {
          text: "Infant Sell",
          value: "infantSell",
          name: "infantSell",
        },
        {
          text: "Cost Currency",
          value: "currencyBuy",
          name: "currencyBuy",
        },
        {
          text: "Cost Exchange",
          value: "currencyBuyExchangeRate",
          name: "currencyBuyExchangeRate",
        },
        {
          text: "Sell Currency",
          value: "currencySell",
          name: "currencySell",
        },
        {
          text: "Sell Exchange",
          value: "currencySellExchangeRate",
          name: "currencySellExchangeRate",
        },
        {
          text: "Rate Type",
          value: "rateType",
          name: "rateType",
        },
        {
          text: "Supplier Comp",
          value: "supplierComp",
          name: "supplierComp",
        },
        {
          text: "Pass Comp",
          value: "passComp",
          name: "passComp",
        },
        {
          text: "Supplier Commission",
          value: "supplierCommission",
          name: "supplierCommission",
        },
      ],
    };
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/PricingLogsDialog.vue